import { DEFAULT_USER_SORT } from '@library/constants/user';
import type { UserRolesGlobalContext } from '@library/types/user';
import { createContext } from 'react';

export const UserRolesContext = createContext<UserRolesGlobalContext>({
  createAdminUser: () => Promise.resolve({} as unknown),
  filters: {
    currentPage: 1,
    filteredRoles: [],
    onSearch: () => {},
    onCurrentPageChange: () => {},
    onFilteredRolesChange: () => {},
    searchValue: ''
  },
  isSelectedUserLoading: false,
  isUserRolesLoading: false,
  modals: {
    createModalOpen: false,
    deactivateUserModalOpen: false,
    editUserDrawerOpen: false,
    onCreateModalOpen: () => {},
    onDeactivateUserModalOpen: () => {},
    onEditUserDrawerOpen: () => {},
    onViewPermissionsDrawerOpen: () => {},
    viewPermissionsDrawerOpen: false
  },
  onSort: () => {},
  onSelectedUserId: () => {},
  onUsersUpdate: () => {},
  selectedUserData: undefined,
  sort: DEFAULT_USER_SORT,
  updateAdminUser: () => Promise.resolve({} as unknown),
  userData: undefined
});
